import React from 'react';
import { prop } from 'ramda';
import { Helmet } from 'react-helmet-async';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import { GENERIC_FAVICONS, IOS_FAVICONS } from './constants';

export const WrapperHelmet = ({ title }) => {
    const htmlBaseClasses = useDeviceSelector(prop('htmlBaseClasses'));
    const timeStamp = useAppSelector(prop('requestStamp'));

    return <Helmet htmlAttributes={{ class: `${htmlBaseClasses} wrapper` }}>
        {title && (<title>{title}</title>)}
        {GENERIC_FAVICONS.map(({ name, sizes }) => (
            <link
                key={name}
                rel={'icon'}
                sizes={sizes}
                href={`/favicons/${name}?t=${timeStamp || Date.now()}`}
            />
        ))}
        <link
            sizes={'196x196'}
            rel={'shortcut icon'}
            href={`/favicons/favicon-196.png?t=${timeStamp || Date.now()}`}
        />
        {IOS_FAVICONS.map(({ name, sizes }) => (
            <link
                key={name}
                sizes={sizes}
                rel={'apple-touch-icon'}
                href={`/favicons/${name}?t=${timeStamp || Date.now()}`}
            />
        ))}
    </Helmet>;
};
